import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { 
  FaCloud, 
  FaEnvelope, 
  // FaPhone, 
  FaMapMarkerAlt,
  // FaFacebook,
  // FaTwitter,
  // FaLinkedin,
  // FaYoutube,
  FaArrowUp
} from 'react-icons/fa';
import { ink, sky } from '../theme';

const FooterContainer = styled.footer`
  background: linear-gradient(180deg, #042248 0%, ${ink} 45%, #020f22 100%);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 60px 0 30px;
  font-family: 'Inter', system-ui, sans-serif;
  color: rgba(255, 255, 255, 0.88);
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 40px;
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const FooterLogo = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  font-size: 1.15rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #ffffff;
  margin-bottom: 20px;

  svg {
    font-size: 2rem;
    color: ${sky};
  }
`;

const FooterDescription = styled.p`
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.6;
  font-size: 0.95rem;
`;

const FooterTitle = styled.h3`
  color: #ffffff;
  font-size: 0.85rem;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  margin-bottom: 15px;
`;

const FooterLink = styled.a`
  color: rgba(255, 255, 255, 0.72);
  text-decoration: none;
  transition: color 0.2s ease, transform 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.95rem;

  &:hover {
    color: ${sky};
    transform: translateX(3px);
  }
`;

// const SocialLinks = styled.div`
//   display: flex;
//   gap: 15px;
//   margin-top: 10px;
// `;

// const SocialLink = styled.a`
//   width: 40px;
//   height: 40px;
//   background: rgba(255, 255, 255, 0.1);
//   border-radius: 50%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   color: white;
//   text-decoration: none;
//   transition: all 0.3s ease;
//   border: 1px solid rgba(255, 255, 255, 0.2);

//   &:hover {
//     background: #00d4ff;
//     transform: translateY(-3px);
//     box-shadow: 0 8px 25px rgba(0, 212, 255, 0.3);
//   }
// `;

const BottomFooter = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  padding-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const Copyright = styled.p`
  color: rgba(255, 255, 255, 0.52);
  font-size: 0.88rem;
`;

const ScrollToTop = styled.button`
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.28);
  color: ${sky};
  width: 50px;
  height: 50px;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);

  &:hover {
    transform: translateY(-3px);
    background: rgba(255, 255, 255, 0.18);
    border-color: rgba(255, 255, 255, 0.45);
    box-shadow: 0 8px 22px rgba(0, 0, 0, 0.25);
  }
`;

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <Container>
        <FooterGrid>
          <FooterSection>
            <FooterLogo>
              <FaCloud />
              E-node platform
            </FooterLogo>
            <FooterDescription>
              Платформа для построения IT систем.
            </FooterDescription>
            <FooterDescription>
              Реестровая запись Министерства цифрового развития №28266 от 19.05.2025
            </FooterDescription>

            {/* <SocialLinks>
              <SocialLink href="#" aria-label="Facebook">
                <FaFacebook />
              </SocialLink>
              <SocialLink href="#" aria-label="Twitter">
                <FaTwitter />
              </SocialLink>
              <SocialLink href="#" aria-label="LinkedIn">
                <FaLinkedin />
              </SocialLink>
              <SocialLink href="#" aria-label="YouTube">
                <FaYoutube />
              </SocialLink>
            </SocialLinks> */}
          </FooterSection>

          {/* <FooterSection>
            <FooterTitle>Продукт</FooterTitle>
            <FooterLink href="#features">Возможности</FooterLink>
            <FooterLink href="#documentation">Документация</FooterLink>
            <FooterLink href="#documentation">Видеоуроки</FooterLink>
            {/* <FooterLink href="#documentation">API</FooterLink>  * /}
            {/* <FooterLink href="#documentation">Интеграции</FooterLink> * / }
          </FooterSection> */}

          <FooterSection>
            <FooterTitle>Поддержка</FooterTitle>
            <FooterLink href="#contact">Связаться с нами</FooterLink>
            {/* <FooterLink href="#documentation">База знаний</FooterLink> */}
            {/* <FooterLink href="#documentation">FAQ</FooterLink> */}
            {/* <FooterLink href="#contact">Техподдержка</FooterLink> */}
            {/* <FooterLink href="#contact">Обучение</FooterLink> */}
          </FooterSection>
{/* 
          <FooterSection>
            <FooterTitle>Компания</FooterTitle>
            <FooterLink href="#contact">О нас</FooterLink>
            <FooterLink href="#contact">Команда</FooterLink>
            <FooterLink href="#contact">Карьера</FooterLink>
            <FooterLink href="#contact">Новости</FooterLink>
            <FooterLink href="#contact">Партнеры</FooterLink>
          </FooterSection> */}

          <FooterSection>
            <FooterTitle>Контакты</FooterTitle>
            <FooterLink href="mailto:info@entcor.ru">
              <FaEnvelope /> info@entcor.ru
            </FooterLink>
            {/* <FooterLink href="tel:+74951234567">
              <FaPhone /> +7 (924) 386-23-34
            </FooterLink> */}
            <FooterLink href="#contact">
              <FaMapMarkerAlt />672039, Россия, г. Чита, <br/> ул. Проезжая, 46, оф. 212
            </FooterLink>
          </FooterSection>
        </FooterGrid>

        <BottomFooter>
          <Copyright>
            © {currentYear} ООО "Энткор-е". Все права защищены.
          </Copyright>
          
          <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <ScrollToTop onClick={scrollToTop} aria-label="Прокрутить наверх">
              <FaArrowUp />
            </ScrollToTop>
          </motion.div>
        </BottomFooter>
      </Container>
    </FooterContainer>
  );
};

export default Footer;
